// 供应商表单的草稿与换算（docs/03 3.4）：名称、状态、备注。供应商不带币种，币种以价格为准（决策 D85）。
import type { Errors } from "@/app/useDraft";
import type { EntityStatus, Input, Supplier } from "@/app/master";

export interface SupplierDraft { name: string; status: EntityStatus; note: string }

export function supplierDraft(row?: Supplier): SupplierDraft {
  return row ? { name: row.name, status: row.status, note: row.note ?? "" } : { name: "", status: "active", note: "" };
}

export function supplierInput(d: SupplierDraft): { body?: Input<Supplier>; errors: Errors<SupplierDraft> } {
  if (!d.name.trim()) return { errors: { name: "填写供应商名称。" } };
  return { errors: {}, body: { name: d.name.trim(), status: d.status, note: d.note.trim() || null } };
}
